export default __webpack_public_path__ + "static/media/water.5facc33ad02589d5b1d40e442fd1c711.png";